<script setup>
import { computed } from 'vue';
import { CdrText } from '@rei/cedar';
import ProgressBar from '../day-checkout/ProgressBar.vue';
import ReservationLookupLoader from './ReservationLookupLoader.vue';
import { useCancellationStore } from '../../stores/day-cancellation';
import ConfirmCancellationLoader from './ConfirmCancellationLoader.vue';

const props = defineProps({
  steps: {
    type: Array,
    required: true,
  },
});

const cancellation = useCancellationStore();

const currentStep = computed(() => props.steps[cancellation.stepIdx]);
const stepCounter = computed(() => `STEP ${cancellation.currentStepNum} OF ${props.steps.length}`);
</script>

<template>
  <section>
    <ProgressBar
      class="day-cancellation-wizard__progress-bar"
      :height="10"
      :current-step="cancellation.currentStepNum"
      :amount-of-steps="props.steps.length"
    />
    <CdrText
      class="day-cancellation-wizard__step-counter"
      data-ui="day-cancellation-wizard-step-counter"
    >
      {{ stepCounter }}
    </CdrText>
    <CdrText
      class="day-cancellation-wizard__title"
      tag="h2"
      data-ui="day-cancellation-wizard-title"
    >
      {{ currentStep.title }}
    </CdrText>
    <div>
      <ReservationLookupLoader
        v-if="cancellation.isLoadingReservationLookup && !cancellation.isLoadingConfirmCancellation"
        class="day-cancellation-wizard__loader"
        data-ui="day-cancellation-wizard-reservation-lookup-loader"
      />
      <ConfirmCancellationLoader
        v-else-if="
          !cancellation.isLoadingReservationLookup && cancellation.isLoadingConfirmCancellation
        "
        class="day-cancellation-wizard__loader"
        data-ui="day-cancellation-wizard-confirm-cancellation-loader"
      />
      <component
        :is="currentStep.component"
        v-else
        :key="cancellation.currentStepNum"
        data-ui="day-cancellation-wizard-component"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.day-cancellation-wizard {
  &__progress-bar {
    max-width: 343px;
    margin-top: $cdr-space-three-x;
  }

  &__title {
    @include cdr-text-heading-serif-500;
    padding-top: $cdr-space-half-x;
  }

  &__step-counter {
    @include cdr-text-utility-sans-strong-100;
    padding-top: $cdr-space-three-quarter-x;
  }

  &__loader {
    margin-top: $cdr-space-one-x;
  }
}
</style>
